import { useDialogForm } from '@mews-commander/form';
import { lt, useDialog } from '@mews/framework';
import { DropDownButton, DropdownItem, Icon, IconButton, IconName, Stack } from '@optimus-web/core';
import { DeleteDialog } from '../../../common/DeleteDialog';
import { DocumentDetailsDialog } from '../details-dialog/DocumentDetailsDialog';
import { EditFileDialogForm } from '../EditFileDialogForm';
import { useDeleteContractMutation } from '../hooks/useDeleteContractMutation';
import { useOpenContractInNewTab } from '../hooks/useOpenContractInNewTab';

interface ActionCellProps {
    documentName: string;
    documentId: string;
}

export const ActionCell = ({ documentName, documentId }: ActionCellProps) => {
    const [{ onClose: onDetailsDialogClose, active: isDetailsDialogActive }, openDetailsDialog] = useDialog();
    const [{ onClose: onDeleteDialogClose, active: isDeleteDialogActive }, openDeleteDialog] = useDialog();
    const [renderEditFileForm, toggleEditFileForm] = useDialogForm({
        renderForm: (props) => <EditFileDialogForm {...props} documentId={documentId} />,
        title: documentName,
    });
    const { mutate: deleteContract, isPending: isContractDeletePending } = useDeleteContractMutation();
    const { mutate: openContract, isPending } = useOpenContractInNewTab();

    return (
        <Stack spacing="100">
            <IconButton
                onClick={() => {
                    openContract({ id: documentId });
                }}
                icon={IconName.Show}
                size="small"
                variant="ghost"
                type="button"
                loading={isPending}
            />
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem
                    label={lt('Details')}
                    leftDetail={<Icon value={IconName.Info} size="small" />}
                    onClick={() => openDetailsDialog()}
                />
                <DropdownItem
                    label={lt('Edit')}
                    leftDetail={<Icon value={IconName.Edit} size="small" />}
                    onClick={() => {
                        toggleEditFileForm();
                    }}
                />
                <DropdownItem
                    label={lt('Delete')}
                    leftDetail={<Icon value={IconName.Delete} size="small" />}
                    onClick={() => openDeleteDialog()}
                />
            </DropDownButton>
            <DeleteDialog
                isActive={isDeleteDialogActive}
                onClose={onDeleteDialogClose}
                title={lt('ContractDeleteConfirmationTitle')}
                description={lt('ContractDeleteConfirmationDescription', { documentName })}
                onDelete={() => deleteContract({ id: documentId }, { onSuccess: onDeleteDialogClose })}
                loading={isContractDeletePending}
            />
            <DocumentDetailsDialog
                isActive={isDetailsDialogActive}
                onClose={() => onDetailsDialogClose()}
                documentId={documentId}
            />
            {renderEditFileForm()}
        </Stack>
    );
};
